import React from "react";

export default function TopHeader(props) {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    input: {
      width: "30%",
      border: "1px solid #E5E5E5",
      padding: "1.5em",
    },
  };
  return (
    <div style={styles.container}>
      <h1 style={{ fontWeight: "700" }}>{props.title}</h1>
      {props.searchBar && (
        <input
          className="form-control-sm"
          type="text"
          placeholder="Search"
          onChange={props.onChange}
          style={styles.input}
        />
      )}
    </div>
  );
}
